// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Flight } from './Flight';
import { Aerodrome } from './Aerodrome';
import { Coordinate } from './Coordinate';
import { FlightPlan } from './FlightPlan';
import { PathPoint } from './PathPoint';
import { PathPointLoadClassification } from './PathPointLoadClassification';

export class ShowFlightsRequest implements IShowFlightsRequest {
    flights!: Flight[];

    constructor(data?: IShowFlightsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flights"])) {
                this.flights = [] as any;
                for (let item of _data["flights"])
                    this.flights!.push(Flight.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShowFlightsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowFlightsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flights)) {
            data["flights"] = [];
            for (let item of this.flights)
                data["flights"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IShowFlightsRequest {
    flights: Flight[];
}